import React, { useContext, Children } from 'react';
import styled from 'styled-components';
import { ButtonStyle } from './Button.styles.js';
import { FormContext } from '../Form/FormContext.js';
import { FormRowContext } from '../FormRow/FormRowContext.js';

const defaultProps = {
    alternative: false,
    color: 'primary',
    compact: false,
    iconPos: 'before',
    plain: false,
    primary: false,
    rounding: 'sharp',
    sizing: 'medium',
    variant: 'outlined',
};
const withClassName = (icon) => {
    const [IconComponent, iconProps] = Array.isArray(icon)
        ? icon
        : 'props' in icon
            ? [icon.type, icon.props]
            : [icon];
    return (React.createElement(IconComponent, { className: "button-icon", key: "button-icon", ...iconProps }));
};
const migrateDeprecatedProps = ({ alternative, color, plain, primary, variant, ...rest }) => ({
    color: color !== null && color !== void 0 ? color : (!primary && alternative ? 'grey' : defaultProps.color),
    variant: variant !== null && variant !== void 0 ? variant : (primary
        ? 'filled'
        : alternative
            ? 'tonal'
            : plain
                ? 'plain'
                : defaultProps.variant),
    ...rest,
});
const Button = styled.button.attrs((props) => {
    // Explicit type annotation is required here to tell TypeScript with
    // @types/react version 18 that the external type interface of the
    // `children` property doesn't change although the `icon` is injected
    // to the `children` property under the hood.
    var _a, _b, _c, _d;
    const migratedProps = migrateDeprecatedProps(props);
    const { children, compact, icon, iconPos: propIconPos, rounding, sizing, variant, } = migratedProps;
    const formRowContext = useContext(FormRowContext);
    const formContext = useContext(FormContext);
    const iconPos = propIconPos !== null && propIconPos !== void 0 ? propIconPos : defaultProps.iconPos;
    const modifiedProps = {
        ...migratedProps,
        // Note: Alternative property is not inherited from FormContext /
        // FormRowContext, because in the purpose of the alternate Button
        // variant veries across brands and it is not intended to be paired
        // with the alternative form field style used in other components.
        children: [
            icon && iconPos === 'before' ? withClassName(icon) : null,
            ...Children.toArray(children),
            icon && iconPos === 'after' ? withClassName(icon) : null,
        ],
        iconPos,
        rounding: (_b = (_a = rounding !== null && rounding !== void 0 ? rounding : formRowContext === null || formRowContext === void 0 ? void 0 : formRowContext.rounding) !== null && _a !== void 0 ? _a : formContext === null || formContext === void 0 ? void 0 : formContext.rounding) !== null && _b !== void 0 ? _b : defaultProps.rounding,
        sizing: (_d = (_c = sizing !== null && sizing !== void 0 ? sizing : formRowContext === null || formRowContext === void 0 ? void 0 : formRowContext.sizing) !== null && _c !== void 0 ? _c : formContext === null || formContext === void 0 ? void 0 : formContext.sizing) !== null && _d !== void 0 ? _d : defaultProps.sizing,
        $iconOnly: !!icon && !children,
        $compactPlain: variant === 'plain' && !!compact,
    };
    return modifiedProps;
}) `
    ${ButtonStyle}
`;

export { Button, defaultProps, migrateDeprecatedProps };
//# sourceMappingURL=Button.js.map
